export default __webpack_public_path__ + "static/broadcast2-87f75fc75fac469ee4e8e3b4c8b46259.png";